// import React, { useEffect, useState } from 'react';
// import { ToastContainer, toast } from 'react-toastify';
// import { BASE_URL, FRONTEND_URL, IMAGE_URL } from '../../config/axios';
// import { Modal } from 'react-bootstrap';
// import 'react-toastify/dist/ReactToastify.css';
// import { Bell } from '../AllSvg';
// import axios from 'axios';
// import { handleErrorToast } from '../CustomFunctions';
// import { ViewPopup } from '../settings/HRActivities/HRActivitiesComponents';
// import Loader from '../Loader';

// const PopUpNotificationModal = () => {
//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => {
//     getPopup();
//     setShow(true)
//   };

//   const [notifications, setNotifications] = useState([]);
//   const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
//   const [unreadCount, setUnreadCount] = useState(0);
//   const [buffer, setBuffering] = useState(true);
//   const [popupData, setPopupData] = useState([]);
//   const today = new Date();


//   const getPopup = async () => {
//     setBuffering(true);
//     try {
//       const fetchPopup = await axios.get(`${BASE_URL}/wfm/popupbysub_company/${toggleCompany}/`);
//       const validPopups = fetchPopup.data.filter((popup) => {
//         const start = new Date(popup.start_visibility);
//         const end = new Date(popup.end_visibility);
//         return today >= start && today <= end;
//       });
//       setNotifications(validPopups);
//       setUnreadCount(validPopups.lengths);
//     } catch (error) {
//       handleErrorToast(error);
//     } finally {
//       setBuffering(false);
//     }
//   }



//   return (
//     <>
//       <button className="" onClick={handleShow}>
//         <div
//           title="Notification Bell"
//           className={`navbar-svg navbar-bell ${unreadCount > 0 ? 'bell-highlight' : ''}`} // Add conditional class if there are unread notifications
//         >
//           <Bell />
//           {unreadCount > 0 && (
//             <span className="notification-count">{unreadCount}</span>
//           )}
//         </div>
//       </button>
//       <Modal
//         show={show}
//         onHide={handleClose}
//         dialogClassName="alert-notifications width-50vw"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Your Notifications</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="notification-container">
//             {
//               buffer ? <Loader container={true} />
//                 :
//                 notifications.length > 0 ? (
//                   notifications.map((i) => (
//                     <div
//                       key={i.id}
//                       className={`notification-item ${i.is_read === "Unread" ? "unread" : "read"
//                         }`}
//                       style={{
//                         position: "relative",
//                         padding: "10px",
//                         borderBottom: "1px solid #e0e0e0",
//                       }}
//                     >
//                       <p>
//                         <strong>Title:</strong> {i.title}
//                       </p>
//                       <ViewPopup key={i.id} i={i} button_varient={'Eye-Name'} />
//                     </div>
//                   ))
//                 ) : (
//                   <div
//                     className="align-center justify-center"
//                     style={{ alignSelf: "center" }}
//                   >
//                     - All Cleared Up 👍 -
//                   </div>
//                 )
//             }
//           </div>
//         </Modal.Body>
//       </Modal>

//     </>
//   );
// };


// const NotificationModal = () => {
//   const [show, setShow] = useState(false);
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);

//   const data = [
//     {
//       "id": 1001,
//       "emp_code": 101,
//       "message": "Your leave request has been approved.",
//       "is_read": "Unread",
//       "created_at": "2024-09-25T10:00:00Z",
//       "rh_assigned": 102
//     },
//     {
//       "id": 1001,
//       "emp_code": 103,
//       "message": "New company policy update available.",
//       "is_read": "Read",
//       "created_at": "2024-09-25T09:30:00Z",
//       "rh_assigned": 104
//     },
//     {
//       "id": 1002,
//       "emp_code": 105,
//       "message": "Reminder: Submit your timesheet by end of the day.",
//       "is_read": "Unread",
//       "created_at": "2024-09-24T18:45:00Z",
//       "rh_assigned": 106
//     },
//     {
//       "id": 1003,
//       "emp_code": 101,
//       "message": "Your leave request has been approved.",
//       "is_read": "Unread",
//       "created_at": "2024-09-25T10:00:00Z",
//       "rh_assigned": 102
//     },
//     {
//       "id": 1004,
//       "emp_code": 103,
//       "message": "New company policy update available.",
//       "is_read": "Read",
//       "created_at": "2024-09-25T09:30:00Z",
//       "rh_assigned": 104
//     },
//     {
//       "id": 1005,
//       "emp_code": 105,
//       "message": "Reminder: Submit your timesheet by end of the day.",
//       "is_read": "Unread",
//       "created_at": "2024-09-24T18:45:00Z",
//       "rh_assigned": 106
//     }
//   ];

//   const fetchData = async () => {
//     const allNotifications = data;
//     setNotifications(allNotifications.filter((n) => n.is_read === 'Unread'));
//     setUnreadCount(allNotifications.filter((n) => n.is_read === 'Unread').length);
//     handleShowNotifications();
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleShowNotifications = () => {
//     notifications.forEach((notification) => {
//       if (notification.is_read === "Unread") {
//         toast(notification.message, {
//           onClose: () => markAsRead(notification.emp_code)
//         });
//       }
//     });
//   };

//   const markAsRead = (id) => {
//     //Switch with Update API
//     console.log("Marking as read for ID:", id); // Debugging line
//     const updatedNotifications = notifications.map((notification) =>
//       notification.id === id
//         ? { ...notification, is_read: "Read" }
//         : notification
//     );
//     console.log("Updated Notifications:", updatedNotifications);
//     // setNotifications(updatedNotifications);
//     setNotifications(updatedNotifications.filter((n) => n.is_read === 'Unread'));
//     setUnreadCount(updatedNotifications.filter((n) => n.is_read === 'Unread').length);
//     console.log("new Notifications:", notifications);

//     // fetchData();
//   };

//   const clearAllNotifications = () => {
//     // Mark all notifications as read
//     const updatedNotifications = notifications.map((notification) => ({
//       ...notification,
//       is_read: 'Read',
//     }));

//     // Update the state with all notifications marked as read
//     setNotifications(updatedNotifications.filter((n) => n.is_read === 'Unread')); // Should result in an empty list of unread notifications
//     setUnreadCount(0); // Set unread count to 0 as all notifications are marked read
//   };

//   return (
//     <>
//       <button className="" onClick={handleShow}>
//         <div
//           title="Notification Bell"
//           className={`navbar-svg navbar-bell ${unreadCount > 0 ? 'bell-highlight' : ''}`} // Add conditional class if there are unread notifications
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="24"
//             height="24"
//             viewBox="0 0 24 24"
//             className="bi bi-box-arrow-right"
//             fill="none"
//           >
//             <g clipPath="url(#clip0_1297_50061)">
//               <path
//                 d="M19.2905 17.29L18.0005 16V11C18.0005 7.93 16.3605 5.36 13.5005 4.68V4C13.5005 3.17 12.8305 2.5 12.0005 2.5C11.1705 2.5 10.5005 3.17 10.5005 4V4.68C7.63054 5.36 6.00054 7.92 6.00054 11V16L4.71054 17.29C4.08054 17.92 4.52054 19 5.41054 19H18.5805C19.4805 19 19.9205 17.92 19.2905 17.29ZM16.0005 17H8.00054V11C8.00054 8.52 9.51054 6.5 12.0005 6.5C14.4905 6.5 16.0005 8.52 16.0005 11V17ZM12.0005 22C13.1005 22 14.0005 21.1 14.0005 20H10.0005C10.0005 21.1 10.8905 22 12.0005 22Z"
//                 fill="#A3AED0"
//               />
//             </g>
//             <defs>
//               <clipPath id="clip0_1297_50061">
//                 <rect width="24" height="24" fill="white" />
//               </clipPath>
//             </defs>
//           </svg>
//           {unreadCount > 0 && (
//             <span className="notification-count">{unreadCount}</span>
//           )}
//         </div>
//       </button>
//       <Modal
//         show={show}
//         onHide={handleClose}
//         dialogClassName="alert-notifications width-50vw"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Your Notifications</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className='notification-container' >
//             <div className="align-center justfy-center">
//               {notifications.length > 0 ?
//                 notifications.map((notification, index) => (
//                   <div key={index} className={`notification-item ${notification.is_read === 'Unread' ? 'unread' : 'read'}`} style={{ position: 'relative', padding: '10px', borderBottom: '1px solid #e0e0e0' }}>
//                     <button
//                       onClick={() => markAsRead(notification.id)}
//                       style={{ position: 'absolute', top: '10px', right: '10px' }} // Positioning the button at the top right
//                     >
//                       <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="24"
//                         height="24"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                       >
//                         <path
//                           d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
//                           stroke="#707070"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                         <path
//                           d="M15 9L9 15"
//                           stroke="#707070"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                         <path
//                           d="M9 9L15 15"
//                           stroke="#707070"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                         />
//                       </svg>
//                     </button>
//                     <p><strong>Message:</strong> {notification.message}</p>
//                     <p><strong>Received At:</strong> {new Date(notification.created_at).toLocaleString()}</p>
//                     <p><strong>Status:</strong> {notification.is_read}</p>
//                     <p><strong>RH Assigned:</strong> {notification.rh_assigned}</p>
//                   </div>
//                 ))
//                 // : <div className='align-center justify-center ' style={{ alignSelf: 'center' }}>- No New Notifications -</div>
//                 : <div className='align-center justify-center ' style={{ alignSelf: 'center' }}>- All Cleared Up 👍 -</div>
//               }

//             </div>
//           </div>
//           {notifications.length > 0 ? <button
//             className='align-center file-clear ' style={{ float: 'right' }}
//             onClick={clearAllNotifications}
//           >
//             Clear
//           </button>
//             : null}
//         </Modal.Body>
//       </Modal>

//     </>
//   );
// };

// const NotificationToast = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [unreadCount, setUnreadCount] = useState(0);

//   const data = [
//     {
//       "emp_code": 101,
//       "message": "Your leave request has been approved.",
//       "is_read": "Unread",
//       "created_at": "2024-09-25T10:00:00Z",
//       "rh_assigned": 102
//     },
//     {
//       "emp_code": 103,
//       "message": "New company policy update available.",
//       "is_read": "Read",
//       "created_at": "2024-09-25T09:30:00Z",
//       "rh_assigned": 104
//     },
//     {
//       "emp_code": 105,
//       "message": "Reminder: Submit your timesheet by end of the day.",
//       "is_read": "Unread",
//       "created_at": "2024-09-24T18:45:00Z",
//       "rh_assigned": 106
//     }
//   ];

//   useEffect(() => {
//     const fetchData = async () => {

//       setNotifications(data);
//       setUnreadCount(data.filter((n) => n.is_read === 'Unread').length);
//     };
//     fetchData();
//   }, []);

//   const handleShowNotifications = () => {
//     notifications.forEach((notification) => {
//       if (notification.is_read === "Unread") {
//         toast(notification.message, {
//           onClose: () => markAsRead(notification.emp_code)
//         });
//       }
//     });
//   };

//   // Function to mark notifications as read
//   const markAsRead = (empCode) => {
//     // Here, you'd normally make an API call to update the notification status
//     // Example API call (replace with your own):
//     // fetch(`/api/notifications/${empCode}`, { method: 'PUT', body: JSON.stringify({ is_read: "Read" }) });

//     // Update local state for now
//     const updatedNotifications = notifications.map((notification) =>
//       notification.emp_code === empCode
//         ? { ...notification, is_read: "Read" }
//         : notification
//     );
//     setNotifications(updatedNotifications);
//     setUnreadCount(updatedNotifications.filter((n) => n.is_read === 'Unread').length);
//   };

//   return (
//     <>
//       <button className="navbar-logo-mobile" onClick={handleShowNotifications}>
//         <div
//           title="Notification Bell"
//           className={`navbar-svg ${unreadCount > 0 ? 'bell-highlight' : ''}`} // Add conditional class if there are unread notifications
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="24"
//             height="24"
//             viewBox="0 0 24 24"
//             fill="none"
//           >
//             <g clipPath="url(#clip0_1297_50061)">
//               <path
//                 d="M19.2905 17.29L18.0005 16V11C18.0005 7.93 16.3605 5.36 13.5005 4.68V4C13.5005 3.17 12.8305 2.5 12.0005 2.5C11.1705 2.5 10.5005 3.17 10.5005 4V4.68C7.63054 5.36 6.00054 7.92 6.00054 11V16L4.71054 17.29C4.08054 17.92 4.52054 19 5.41054 19H18.5805C19.4805 19 19.9205 17.92 19.2905 17.29ZM16.0005 17H8.00054V11C8.00054 8.52 9.51054 6.5 12.0005 6.5C14.4905 6.5 16.0005 8.52 16.0005 11V17ZM12.0005 22C13.1005 22 14.0005 21.1 14.0005 20H10.0005C10.0005 21.1 10.8905 22 12.0005 22Z"
//                 fill="#A3AED0"
//               />
//             </g>
//             <defs>
//               <clipPath id="clip0_1297_50061">
//                 <rect width="24" height="24" fill="white" />
//               </clipPath>
//             </defs>
//           </svg>
//           {unreadCount > 0 && (
//             <span className="notification-count">{unreadCount}</span>
//           )}
//         </div>
//       </button>
//       <ToastContainer
//         position="top-center"
//         autoClose={false}
//         newestOnTop={true}
//         draggable
//       />
//     </>
//   );
// };

// const NotificationHistoryTable = () => {
//   return (
//     <>
//       <div className="navbar-logo-mobile">
//         <div title="Notification" className="navbar-svg">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="24"
//             height="24"
//             viewBox="0 0 24 24"
//             fill="none"
//           >
//             <g clipPath="url(#clip0_1297_50061)">
//               <path
//                 d="M19.2905 17.29L18.0005 16V11C18.0005 7.93 16.3605 5.36 13.5005 4.68V4C13.5005 3.17 12.8305 2.5 12.0005 2.5C11.1705 2.5 10.5005 3.17 10.5005 4V4.68C7.63054 5.36 6.00054 7.92 6.00054 11V16L4.71054 17.29C4.08054 17.92 4.52054 19 5.41054 19H18.5805C19.4805 19 19.9205 17.92 19.2905 17.29ZM16.0005 17H8.00054V11C8.00054 8.52 9.51054 6.5 12.0005 6.5C14.4905 6.5 16.0005 8.52 16.0005 11V17ZM12.0005 22C13.1005 22 14.0005 21.1 14.0005 20H10.0005C10.0005 21.1 10.8905 22 12.0005 22Z"
//                 fill="#A3AED0"
//               />
//             </g>
//             <defs>
//               <clipPath id="clip0_1297_50061">
//                 <rect width="24" height="24" fill="white" />
//               </clipPath>
//             </defs>
//           </svg>
//         </div>
//         <div>
//           <img src={`${IMAGE_URL}${sessionStorage.getItem("profilepic")}`} alt="image" className="navbar-user-login" />
//         </div>
//       </div>
//     </>
//   );
// };

// export { PopUpNotificationModal, NotificationModal, NotificationToast, NotificationHistoryTable };


import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom"; // <-- Import useNavigate
import { Bell, FileTextIcon, CloseIcon, CheckIcon, ClockIcon, ChevronRightIcon, DownloadIcon, Eye, CheckTick } from '../AllSvg';
import { BASE_URL, FRONTEND_URL } from "../../config/axios";

const POLL_INTERVAL = 30000; // 30 seconds polling

// ─── Document Viewer Modal ───────────────────────────────────────────────────
const DocumentViewer = ({ doc, onClose }) => {
  if (!doc) return null;

  const typeColorMap = {
    "Offer Letter": { bg: "#B5D4F4", color: "#0C447C" },
    "Payslip": { bg: "#C0DD97", color: "#27500A" },
    "Appraisal": { bg: "#FAC775", color: "#633806" },
    "Contract": { bg: "#F4C0D1", color: "#72243E" },
  };
  const colors = typeColorMap[doc.document_type] || { bg: "#D3D1C7", color: "#444441" };

  // Ensure file URL works whether it's absolute or relative
  const fileUrl = doc.document_file?.startsWith('http')
    ? doc.document_file
    : `https://cipl-aimantra.s3.amazonaws.com/${doc.document_file}`;

  return (
    <div
      onClick={(e) => e.target === e.currentTarget && onClose()}
      style={{
        position: "fixed", inset: 0,
        background: "rgba(0,0,0,0.5)", zIndex: 1060,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "16px",
      }}
    >
      <div style={{
        width: "100%", maxWidth: "520px",
        background: "#fff", borderRadius: "16px",
        overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
        animation: "slideIn 0.2s ease",
      }}>
        {/* Header */}
        <div style={{
          padding: "14px 16px",
          borderBottom: "1px solid #eee",
          display: "flex", alignItems: "center", gap: "12px",
        }}>
          <div style={{
            width: 40, height: 40, borderRadius: "8px",
            background: colors.bg, color: colors.color,
            display: "flex", alignItems: "center", justifyContent: "center",
            flexShrink: 0,
          }}>
            <FileTextIcon size={20} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontWeight: 600, fontSize: "15px", margin: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {doc.document_name || doc.title}
            </p>
            <p style={{ fontSize: "12px", color: "#888", margin: 0 }}>{doc.document_type}</p>
          </div>
          {doc.is_seen ? (
            <span style={{ fontSize: "11px", padding: "2px 8px", borderRadius: "20px", background: "#EAF3DE", color: "#27500A", display: "flex", alignItems: "center", gap: "4px" }}>
              <CheckIcon size={11} /> Seen
            </span>
          ) : (
            <span style={{ fontSize: "11px", padding: "2px 8px", borderRadius: "20px", background: "#B5D4F4", color: "#0C447C", display: "flex", alignItems: "center", gap: "4px" }}>
              Just seen
            </span>
          )}
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#aaa", padding: "4px", borderRadius: "6px" }}>
            <CloseIcon size={18} />
          </button>
        </div>

        {/* Meta bar */}
        <div style={{ padding: "10px 16px", background: "#f8f9fa", borderBottom: "1px solid #eee", display: "flex", gap: "20px", flexWrap: "wrap" }}>
          <div style={{ fontSize: "12px", color: "#888" }}>
            Type: <strong style={{ color: "#333" }}>{doc.document_type || "Document"}</strong></div>
          {(doc.created_at || doc.send_date) && (
            <div style={{ fontSize: "12px", color: "#888" }}>Date: <strong style={{ color: "#333" }}>{new Date(doc.created_at || doc.send_date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</strong></div>
          )}
        </div>

        {/* Actions */}
        <div style={{ padding: "12px 16px", display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <button className="model-button model-button-cancel font-weight500" onClick={onClose}>
            Close
          </button>
          {doc.document_file && (
            <a
              href={fileUrl}
              target="_blank" rel="noreferrer"
              style={{ fontSize: "13px", padding: "8px 16px", borderRadius: "8px", background: "#185FA5", color: "#fff", textDecoration: "none", display: "flex", alignItems: "center", gap: "6px" }}
            >
              {/* <Eye size={14} />  */}
              View Document
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

// ─── Single Notification Item ─────────────────────────────────────────────────
const NotifItem = ({ item, onClick }) => {
  const typeIconMap = {
    "Offer Letter": { bg: "#B5D4F4", color: "#0C447C" },
    "Payslip": { bg: "#C0DD97", color: "#27500A" },
    "Appraisal": { bg: "#FAC775", color: "#633806" },
    "Contract": { bg: "#F4C0D1", color: "#72243E" },
    "appreciation": { bg: "#C0DD97", color: "#27500A" },
    "positive": { bg: "#B5D4F4", color: "#0C447C" },
    "warning": { bg: "#F4C0D1", color: "#72243E" },
    "neutral": { bg: "#e2e8f0", color: "#475569" },
  };
  const colors = typeIconMap[item.document_type?.toLowerCase()] || { bg: "#D3D1C7", color: "#444441" };

  return (
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick()}
      style={{
        padding: "12px 16px 12px 20px",
        display: "flex", alignItems: "flex-start", gap: "12px",
        cursor: "pointer", transition: "background 0.12s",
        background: item.is_seen ? "transparent" : "#EBF4FD",
        borderBottom: "1px solid #f0f0f0",
        position: "relative",
      }}
      onMouseEnter={(e) => e.currentTarget.style.background = item.is_seen ? "#f8f9fa" : "#ddedf8"}
      onMouseLeave={(e) => e.currentTarget.style.background = item.is_seen ? "transparent" : "#EBF4FD"}
    >
      {/* Unread dot */}
      {!item.is_seen && (
        <span style={{ position: "absolute", top: 16, left: 7, width: 6, height: 6, borderRadius: "50%", background: "#378ADD" }} />
      )}

      {/* Icon */}
      <div style={{ width: 36, height: 36, borderRadius: "8px", background: colors.bg, color: colors.color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <FileTextIcon size={18} />
      </div>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: "13px", fontWeight: item.is_seen ? 400 : 600, color: "#222", margin: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: 'capitalize' }}>
          {item.document_name || item.title}
        </p>
        <p style={{ fontSize: "12px", color: "#888", margin: "2px 0 0", lineHeight: 1.4, textTransform: 'capitalize' }}>
          {item.document_type || "Document"} {item.notif_type === 'letter' ? 'Letter' : ''}
        </p>

        {(item.created_at || item.send_date) && (
          <p style={{ fontSize: "11px", color: "#aaa", margin: "4px 0 0", display: "flex", alignItems: "center", gap: "4px" }}>
            <ClockIcon size={11} />
            {new Date(item.created_at || item.send_date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
          </p>
        )}
      </div>

      <ChevronRightIcon size={16} style={{ color: "#ccc", alignSelf: "center" }} />
    </div>
  );
};

const PopUpNotificationModal = () => {
  const [show, setShow] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [bellAnimate, setBellAnimate] = useState(false);

  const pollingRef = useRef(null);
  const navigate = useNavigate();
  const employeeId = sessionStorage.getItem("emp_code");


  // ── Fetch notifications & unread count ──────────────────────────────
  const fetchDocumentData = useCallback(async (showLoading = false) => {
    const currentEmpCode = sessionStorage.getItem("emp_code");

    if (!currentEmpCode) {
      console.warn("Attempted to fetch notifications, but emp_code is missing.");
      return; // Exit early if no ID
    }
    if (showLoading) setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/userdata/employee-document-notification-count/`, {
        params: { emp_code: currentEmpCode },
      });

      // Calculate total count (Documents + Letters)
      const totalCount = (res.data?.unseen_count || 0) + (res.data?.letter_count || 0);

      // Extract arrays
      const docs = res.data?.docuemnt_details || res.data?.document_details || [];
      const letters = res.data?.letter_details || [];

      setNotifications((prev) => {
        // Keep track of what was already marked as 'seen' locally
        const seenStatusMap = new Map(prev.map(item => [item.id, item.is_seen]));

        // 1. Normalize Documents
        const normalizedDocs = docs.map(doc => ({
          ...doc,
          notif_type: 'document',
          is_seen: seenStatusMap.has(doc.id) ? seenStatusMap.get(doc.id) : false
        }));

        // 2. Normalize Letters to match Document structure
        const normalizedLetters = letters.map(letter => ({
          ...letter,
          notif_type: 'letter',
          document_name: letter.letter_name || letter.subject || "Employee Letter",
          document_type: letter.letter_type || "Letter",
          is_seen: seenStatusMap.has(letter.id) ? seenStatusMap.get(letter.id) : false
        }));

        // Combine and sort (newest first)
        const combined = [...normalizedDocs, ...normalizedLetters].sort((a, b) => {
          return new Date(b.created_at || 0) - new Date(a.created_at || 0);
        });

        return combined;
      });

      if (totalCount > unreadCount) {
        // New notification arrived — animate bell
        setBellAnimate(true);
        setTimeout(() => setBellAnimate(false), 800);
      }
      setUnreadCount(totalCount);
    } catch (err) {
      console.error("Error fetching notifications", err);
    } finally {
      if (showLoading) setLoading(false);
    }
  }, [employeeId, unreadCount]);

  // ── Mark a single notification as seen ─────────────────────────────────
  const markSeen = async (docId, isLetter = false) => {
    try {
      const payload = {
        emp_code: employeeId,
        ...(isLetter ? { letter_id: docId } : { document_id: docId }),
      };
      await axios.put(`${BASE_URL}/userdata/employee-document-mark-seen/`, payload);

      setNotifications((prev) =>
        prev.map((n) => (n.id === docId ? { ...n, is_seen: true } : n))
      );
      setUnreadCount((prev) => Math.max(0, prev - 1));
    } catch (_) { }
  };

  // ── Mark all as seen ────────────────────────────────────────────────────
  const markAllSeen = async () => {
    const unseen = notifications.filter((n) => !n.is_seen);
    await Promise.allSettled(unseen.map((n) => markSeen(n.id, n.notif_type === 'letter')));
  };

  // ── Open a document OR Route to Letter ──────────────────────────────────
  const handleNotifClick = async (item) => {
    if (!item.is_seen) {
      await markSeen(item.id, item.notif_type === 'letter');
    }

    if (item.notif_type === 'letter') {
      const url = `${FRONTEND_URL}/employeeLetterView/${item.id}/?emp=${employeeId ? employeeId : sessionStorage.getItem("emp_code")}`;
      window.open(url, "_blank", "noopener", "noreferrer");
    } else {
      setSelectedDoc({ ...item, is_seen: true });
    }
  };

  // ── Open modal ──────────────────────────────────────────────────────────
  const handleOpen = () => {
    setShow(true);
    fetchDocumentData(true);
  };

  // ── Polling on mount ──────────────────────
  useEffect(() => {
    fetchDocumentData();
    pollingRef.current = setInterval(() => fetchDocumentData(false), POLL_INTERVAL);
    return () => clearInterval(pollingRef.current);
  }, [fetchDocumentData]);

  return (
    <>
      {/* ── Bell Button ── */}
      <button
        onClick={handleOpen}
        title="Notifications"
        aria-label={`Notifications${unreadCount > 0 ? `, ${unreadCount} unread` : ""}`}
        className={`navbar-svg navbar-bell ${bellAnimate ? "bell-ring" : ""}`}
        style={{ position: "relative", background: "none", border: "none", cursor: "pointer", padding: "6px" }}
      >
        <Bell size={20} />
        {unreadCount > 0 && (
          <span
            className="notification-count"
            style={{ top: '5px', right: '5px' }}
          >
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>

      {/* ── Notification Panel Modal ── */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="notification-panel-dialog"
        style={{ zIndex: 1050 }}
      >
        <Modal.Header closeButton style={{ padding: "14px 16px", borderBottom: "1px solid #f0f0f0" }}>
          <div style={{ flex: 1 }}>
            <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>Notifications</Modal.Title>
            <p style={{ fontSize: "12px", color: "#888", margin: 0 }}>
              {unreadCount > 0 ? `${unreadCount} unread` : "All caught up"}
            </p>
          </div>
          {unreadCount > 0 && (
            <button
              onClick={markAllSeen}
              style={{ fontSize: "12px", color: "#185FA5", background: "none", border: "none", cursor: "pointer", marginRight: "8px" }}
            >
              Mark all read
            </button>
          )}
        </Modal.Header>

        {/* Modal Body rendering notifications directly */}
        <Modal.Body style={{ padding: 0, maxHeight: "60vh", overflowY: "auto" }}>
          {loading ? (
            <div style={{ padding: "40px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>
              Loading notifications...
            </div>
          ) : notifications.length > 0 ? (
            notifications.map((item) => (
              <NotifItem key={item.id} item={item} onClick={() => handleNotifClick(item)} />
            ))
          ) : (
            <div className="flex flex-column align-center justify-center gap-2" style={{ padding: "40px 10px" }}>
              {/* <div style={{ fontSize: "32px", marginBottom: "8px" }}>✅</div> */}
              <div style={{ backgroundColor: "#58d68e", padding: '4px 8px', borderRadius: "8px" }}><CheckTick color="#FFFFFF" /></div>
              <div style={{ fontSize: "14px", fontWeight: 500, color: "#333" }}>All caught up!</div>
              <div style={{ fontSize: "12px", color: "#aaa" }}>No new notifications</div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ── Document Viewer ── */}
      {selectedDoc && (
        <DocumentViewer doc={selectedDoc} onClose={() => setSelectedDoc(null)} />
      )}

      {/* Inline animation keyframe */}
      <style>{`
        @keyframes bellRing {
          0%,100%{transform:rotate(0)} 20%{transform:rotate(-15deg)} 40%{transform:rotate(15deg)} 60%{transform:rotate(-10deg)} 80%{transform:rotate(10deg)}
        }
        .bell-ring { animation: bellRing 0.6s ease; }
        .notification-panel-dialog { max-width: 440px !important; margin-left: auto !important; margin-right: 16px !important; margin-top: 60px !important; }
        .notification-panel-dialog .modal-content { border-radius: 16px !important; border: 1px solid #eee !important; box-shadow: 0 16px 48px rgba(0,0,0,0.15) !important; }
        @keyframes slideIn { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:translateY(0)} }
      `}</style>
    </>
  );
};

export { PopUpNotificationModal };